//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableauUserAccessService from '@/apps/data-platform/services/visualization/tableauRol';
import { PATTERNS_VALIDATION } from '@/js/constants';
export default {
  name: 'UserAccessNew',
  props: {
    record: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      modalUserAccessNew: 'modalUserAccessNew',
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      dismissCountDown: 0,
      dangerMessage: '',
      dismissSecs: 5
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;
      var formElement = this.$refs.form;
      console.log(formElement.validate());
      if (!formElement.validate()) return;
      var params = {
        record: {
          document_id: this.record.name,
          user_dp: this.record.user_dp
        }
      };
      TableauUserAccessService.assignRolUser(params).then(function (response) {
        if (response.data.success) {
          _this.$bvModal.hide(_this.modalUserAccessNew);
          _this.$bus.$emit('onReloadDetail');
        } else {
          _this.dismissCountDown = _this.dismissSecs;
          _this.dangerMessage = response.data.message;
        }
      });
    },
    resetModal: function resetModal() {
      this.$bvModal.hide(this.modalUserAccessNew);
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};